import api from "api/config";

/* Create Client */
export const CreateClientAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/setup/create-admin",
    data,
  });
  return response;
};

/* Get All Clients */
export const GetClientsAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/setup/admin/list",
    data,
  });
  return response;
};

/* Get Single Client */
export const GetClientByIdAPI = async (clientId) => {
  const response = await api({
    method: "GET",
    url: `/api/v1/setup/admin/${clientId}`,
  });
  return response;
};

/* Update Client */
export const UpdateClientAPI = async (data) => {
  const response = await api({
    method: "PUT",
    url: `api/v1/setup/admin/${data.id}`,
    data,
  });
  return response;
};

/* Update Admin Status */

export const UpdateAdminStatusAPI = async ({ userId, action }) => {
  const response = await api({
    method: "PATCH",
    url: `api/v1/setup/admin/${userId}/changeStatus`,
    data: {
      status: action,
    },
  });
  return response;
};

/* Delete Client */
export const DeleteClientAPI = async (clientId) => {
  const response = await api({
    method: "PATCH",
    url: `api/v1/setup/admin/${clientId}/softDelete?confirm=true`,
  });
  return response;
};
